import { Link } from 'react-router-dom';
import { HelpCircle, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

/**
 * HelpBlock - Bloc d'aide "Besoin d'une pièce spécifique ?"
 * 
 * Positionné à côté de la barre de recherche pour être visible immédiatement.
 * Responsive : à droite sur desktop, en dessous sur mobile.
 */
const HelpBlock = ({ className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-[#1E3A5F]/5 to-[#F97316]/5 border border-[#1E3A5F]/20 rounded-xl p-4 ${className}`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 bg-[#1E3A5F] rounded-lg flex items-center justify-center">
          <HelpCircle className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-[#0F172A] text-sm mb-1">
            Besoin d'une pièce spécifique ?
          </h3>
          <p className="text-slate-600 text-xs leading-relaxed mb-3">
            Vous ne trouvez pas la référence recherchée ? Contactez-nous, nous vous aiderons à identifier la bonne pièce.
          </p>
          <Link to="/contact">
            <Button 
              size="sm" 
              className="bg-[#1E3A5F] hover:bg-[#0F172A] text-white text-xs h-8 px-3"
            >
              <MessageCircle className="w-3.5 h-3.5 mr-1.5" />
              Contacter le support
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HelpBlock;
